export default __webpack_public_path__ + "static/media/white.6461a648.png";